// Action Creators
// Constants
import { PlanType } from "@ms/uno-constants/lib/local/AppConstants";
import { ModalType } from "@ms/uno-constants/lib/local/ModalType";
/** Opens the confirmation dialog for disconnecting a task from its linked plan. */ export const openDisconnectPlanModal = (isDisconnectPlanEnabled, sourceTaskId, sourcePlan, planLinkActionCreator, onDismiss)=>{
    if (!isDisconnectPlanEnabled || sourcePlan?.getPlanType() !== PlanType.Unified) {
        return;
    }
    const modalData = {
        modalType: ModalType.DisconnectPlan,
        sourceTaskId,
        onDismiss
    };
    planLinkActionCreator.openDisconnectPlanModal(modalData);
};
